import React from 'react';

import type { MailersHeader } from 'bundles/connect/types';
import { DEFAULT_FONT_FAMILY } from '../../rich_text_editor/tiptap_editor';

type PreviewHeaderProps = {
  header: MailersHeader;
};

export default function PreviewHeader({ header }: PreviewHeaderProps) {
  if (!header.htmlLeft && !header.htmlRight && !header.logoUrl) {
    return <></>;
  }

  return (
    <div
      className="d-flex align-items-start justify-content-between border-bottom"
      style={{ fontFamily: DEFAULT_FONT_FAMILY }}
    >
      <div>
        {header.logoUrl && <img src={header.logoUrl} style={{ maxHeight: '200px', maxWidth: '200px' }} />}
        <div dangerouslySetInnerHTML={{ __html: header.htmlLeft }} />
      </div>
      <div dangerouslySetInnerHTML={{ __html: header.htmlRight }} />
    </div>
  );
}
